import { Box } from "@mui/material";
import Sarodi from "../../images/sarodi.svg";

const SideBar = () => {
  return (
    <Box
      sx={{
        paddingTop: { xs: "3rem", lg: "5rem", xl: "8rem" },
        left: { xs: "1rem", md: "5rem" },
        alignItems: "flex-end",
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: { xs: "8rem", md: "15rem" },
        }}
      >
        <img
          src={Sarodi}
          style={{
            paddingLeft: "10rem",
            width: "100%",
            height: "100%",
          }}
          alt="Sarodi icon."
        />
      </Box>
      <Box
        sx={{
          width: "2px",
          minHeight: { xs: "84dvh", md: "80dvh" },
          background: "#8B8B8B",
        }}
      />
    </Box>
  );
};

export default SideBar;
